module.exports = __webpack_public_path__ + "img/5.67450851.jpg";